/**
* @license Apache-2.0
*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

// VARIABLES //

var SQRT1O12 = 0.28867513459481287; // sqrt( 1.0/12.0 );


// MAIN //

/**
* Returns the standard deviation of a uniform distribution.
*
* @param {number} a - minimum support
* @param {number} b - maximum support
* @returns {PositiveNumber} standard deviation
*
* @example
* var v = stdev( 0.0, 1.0 );
* // returns ~0.289
*
* @example
* var v = stdev( 4.0, 12.0 );
* // returns ~2.309
*
* @example
* var v = stdev( -4.0, 4.0 );
* // returns ~2.309
*
* @example
* var v = stdev( 1.0, -0.1 );
* // returns NaN
*
* @example
* var v = stdev( 2.0, NaN );
* // returns NaN
*
* @example
* var v = stdev( NaN, 2.0 );
* // returns NaN
*/
function stdev( a, b ) {
	if (
		a >= b
	) {
		return NaN;
	}
	return SQRT1O12 * ( b-a );
}


// EXPORTS //

export default stdev;
